import React from 'react';
import AddElementModal from './AddElementModal';

export type AddingNewElement = { name: string; desc: string; episodes: number[]; loading: boolean };

const EMPTY_ADDING: AddingNewElement = { name: '', desc: '', episodes: [], loading: false };

export const AddNewElementRow: React.FC<{
  label: string;
  descPlaceholder: string;
  adding: AddingNewElement | null;
  setAdding: React.Dispatch<React.SetStateAction<AddingNewElement | null>>;
  onConfirm: (name: string, desc: string, episodes: number[]) => void;
  availableEpisodes: readonly { episodeIndex: number; title?: string }[];
  themeColor?: string;
}> = ({ label, descPlaceholder, adding, setAdding, onConfirm, availableEpisodes, themeColor }) => {
  return (
    <>
      <button
        onClick={() => setAdding({ ...EMPTY_ADDING })}
        style={{
          alignSelf: 'flex-start', marginTop: '0.25rem',
          background: 'none', border: `1px dashed ${themeColor || 'var(--border)'}`,
          color: themeColor || 'var(--text-3)', borderRadius: '6px',
          padding: '5px 14px', fontSize: '0.82rem', cursor: 'pointer',
          display: 'flex', alignItems: 'center', gap: '4px',
        }}
      >
        <span style={{ fontSize: '1rem' }}>+</span> {label}
      </button>
      <AddElementModal
        open={!!adding}
        title={label}
        descPlaceholder={descPlaceholder}
        value={adding ?? EMPTY_ADDING}
        onChange={setAdding}
        onConfirm={onConfirm}
        onClose={() => setAdding(null)}
        availableEpisodes={availableEpisodes}
        themeColor={themeColor}
      />
    </>
  );
};
